import { render } from "./ServerCenterPDF.vue?vue&type=template&id=b0b4d30c&scoped=true"
import script from "./ServerCenterPDF.vue?vue&type=script&lang=js"
export * from "./ServerCenterPDF.vue?vue&type=script&lang=js"

import "./ServerCenterPDF.vue?vue&type=style&index=0&id=b0b4d30c&lang=less&scoped=true"

import exportComponent from "D:\\workspace\\forome\\site-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0b4d30c"]])

export default __exports__